// frontend/src/components/admin/reseller/CreditDialog.js
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const CreditDialog = ({
  open,
  onClose,
  onSubmit,
  amount,
  setAmount,
  reason,
  setReason,
  loading,
  selectedReseller,
}) => {
  const { t } = useTranslation();
  const isDeduction = amount && parseFloat(amount) < 0;

  const handleSubmit = () => {
    if (isDeduction && !reason.trim()) {
      return;
    }
    onSubmit();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {t("admin.resellers.adjustCredits")}
        {selectedReseller && ` - ${selectedReseller.username}`}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <TextField
            autoFocus
            label={t("admin.resellers.creditAmount")}
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            fullWidth
            helperText={t("admin.resellers.creditAmountHelp")}
            disabled={Boolean(loading)}
          />
          <TextField
            label={t("admin.resellers.creditReason")}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            fullWidth
            required={Boolean(isDeduction)} // Ensure `required` is boolean
            error={Boolean(isDeduction && !reason.trim())} // Ensure `error` is boolean
            helperText={
              isDeduction && !reason.trim()
                ? t("admin.resellers.creditReasonRequired")
                : ""
            }
            disabled={Boolean(loading)}
            multiline
            rows={2}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={Boolean(loading)}>
          {t("common.actions.cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={Boolean(loading || (isDeduction && !reason.trim()))}
        >
          {loading ? <CircularProgress size={24} /> : t("common.actions.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreditDialog;
